export default ({ form, field }) => ({ totalWidth, totalHeight }) => ({ nativeEvent: { offsetX, offsetY } }) => {
  const x = offsetX / totalWidth
  const y = offsetY / totalHeight
  form.setFieldValue(field.name, { x, y })
}
